import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { submitContactForm } from 'src/lib/contactApi';

export default function ContactModal({ isOpen, onClose }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const handleClose = () => {
        if (!submitted) {
            setName(''); setEmail(''); setSubject(''); setMessage(''); setError(null);
        }
        setSubmitted(false);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);
        try {
            await submitContactForm({ name, email, subject, message });
            setSubmitted(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        className="themed-modal-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        onClick={handleClose}
                    />
                    <motion.div
                        className="themed-modal"
                        style={{ maxWidth: 520 }}
                        initial={{ opacity: 0, scale: 0.97, x: '-50%', y: 'calc(-50% + 16px)' }}
                        animate={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
                        exit={{ opacity: 0, scale: 0.97, x: '-50%', y: 'calc(-50% + 16px)' }}
                        transition={{ duration: 0.25, ease: 'easeOut' }}
                    >
                        <div className="themed-modal-accent-bar" />
                        <div className="themed-modal-body">
                            <button
                                className="themed-modal-close"
                                onClick={handleClose}
                                aria-label="Close"
                            >
                                ✕
                            </button>

                            {submitted ? (
                                <div className="modal-success">
                                    <p className="modal-success-title">Thank you.</p>
                                    <p className="modal-success-sub">I'll get back to you when I can.</p>
                                    <button className="modal-cta-btn" onClick={handleClose}>
                                        Close
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <h2 className="themed-modal-title">Get in touch</h2>
                                    <p className="themed-modal-subtitle" style={{ marginBottom: 24 }}>
                                        Whether it's about craft, collaboration, or just to say hello.
                                    </p>
                                    <form className="contact-form" onSubmit={handleSubmit}>
                                        <div className="contact-form-row">
                                            <div className="contact-form-field">
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    className="contact-form-input"
                                                    value={name}
                                                    onChange={e => setName(e.target.value)}
                                                    required
                                                    placeholder="Your name"
                                                />
                                            </div>
                                            <div className="contact-form-field">
                                                <label>Email</label>
                                                <input
                                                    type="email"
                                                    className="contact-form-input"
                                                    value={email}
                                                    onChange={e => setEmail(e.target.value)}
                                                    required
                                                    placeholder="your@email.com"
                                                />
                                            </div>
                                        </div>
                                        <div className="contact-form-field">
                                            <label>Subject</label>
                                            <input
                                                type="text"
                                                className="contact-form-input"
                                                value={subject}
                                                onChange={e => setSubject(e.target.value)}
                                                required
                                                placeholder="What's on your mind?"
                                            />
                                        </div>
                                        <div className="contact-form-field">
                                            <label>Message</label>
                                            <textarea
                                                className="contact-form-input"
                                                value={message}
                                                onChange={e => setMessage(e.target.value)}
                                                required
                                                rows={5}
                                                placeholder="Your message…"
                                            />
                                        </div>
                                        {error && <p className="auth-error">{error}</p>}
                                        <button
                                            type="submit"
                                            className="auth-submit-btn"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? 'Sending…' : 'Send message'}
                                        </button>
                                    </form>
                                </>
                            )}
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
